export default __webpack_public_path__ + "static/media/purple_perks.6d9db781.png";